// English translations. Keys are the Romanian SOURCE strings used in the UI.
// Missing keys fall back to the Romanian source, so the app never breaks.
export const EN = {
  // ---- Nav / Header ----
  "Studio AI": "AI Studio",
  "Proiecte": "Projects",
  "Catalog": "Catalog",
  "Cereri ofertă": "Offer requests",
  "Administrare": "Administration",
  "Foto": "Photo",
  "Cereri": "Requests",
  "Admin": "Admin",
  "Vânzări": "Sales",
  "Client": "Client",
  "Magazin KLUS": "KLUS Shop",
  "Proiectele mele": "My projects",
  "Instalează aplicația": "Install the app",
  "Deconectare": "Log out",
  "Autentificare": "Sign in",
  "Creează cont": "Create account",

  // ---- Common ----
  "Se încarcă…": "Loading…",
  "Salvează": "Save",
  "Anulează": "Cancel",
  "Șterge": "Delete",
  "Închide": "Close",
  "Înapoi": "Back",
  "Trimite": "Send",
  "Descarcă": "Download",
  "Continuă": "Continue",
  "Deschide aplicația": "Open the app",

  // ---- Auth pages ----
  "Autentificare reușită": "Signed in successfully",
  "Bine ai revenit": "Welcome back",
  "Autentifică-te pentru a genera randări.": "Sign in to generate renders.",
  "Parolă": "Password",
  "Ai uitat parola?": "Forgot your password?",
  "Nu ai cont?": "No account?",
  "Instalează aplicația pe telefon sau PC": "Install the app on phone or PC",
  "Câteva date și ești gata să generezi prima randare.": "A few details and you're ready to generate your first render.",
  "Tip client": "Client type",
  "Persoană fizică": "Individual",
  "Persoană juridică": "Company",
  "Nume complet": "Full name",
  "Parolă (min. 6)": "Password (min. 6)",
  "Telefon": "Phone",
  "Firmă": "Company",
  "Reg. Com.": "Trade Reg.",
  "Județ *": "County *",
  "— alege județul —": "— choose county —",
  "Util pentru a-ți repartiza un partener KLUS din zona ta.": "Useful for assigning you a KLUS partner in your area.",
  "Sunt de acord cu prelucrarea datelor mele cu caracter personal de către": "I agree to the processing of my personal data by",
  "conform GDPR pentru contactare comercială și statistici interne. Vezi": "under GDPR for commercial contact and internal statistics. See",
  "politica de confidențialitate": "the privacy policy",
  "Doresc să primesc oferte și recomandări de design de la KLUS (opțional, poate fi retras oricând).": "I want to receive offers and design recommendations from KLUS (optional, can be withdrawn anytime).",
  "Ai deja cont?": "Already have an account?",
  "Autentifică-te": "Sign in",
  "Consimțământul GDPR este obligatoriu.": "GDPR consent is required.",
  "Selectează județul.": "Select your county.",
  "Cont creat! Poți genera prima randare.": "Account created! You can generate your first render.",
  "Verifică emailul pentru linkul de resetare.": "Check your email for the reset link.",
  "Verifică-ți emailul": "Check your email",
  "Dacă există un cont cu": "If an account exists for",
  "ai primit un link de resetare valabil 1 oră.": "you've received a reset link valid for 1 hour.",
  "Înapoi la autentificare": "Back to sign in",
  "Îți trimitem un link de resetare pe email.": "We'll send you a reset link by email.",
  "Trimite linkul": "Send the link",
  "Parola trebuie să aibă minim 6 caractere.": "Password must be at least 6 characters.",
  "Parolele nu coincid.": "Passwords do not match.",
  "Parola a fost resetată.": "Password has been reset.",
  "Setează o parolă nouă": "Set a new password",
  "Alege o parolă sigură pentru contul tău.": "Choose a secure password for your account.",
  "Link invalid. Solicită din nou resetarea din pagina „Ai uitat parola?\".": "Invalid link. Request a reset again from the \"Forgot your password?\" page.",
  "Parolă nouă": "New password",
  "Confirmă parola": "Confirm password",
  "Resetează parola": "Reset password",

  // ---- Install page + banner ----
  "Instalare aplicație": "Install app",
  "Instalează KLUS AI Studio": "Install KLUS AI Studio",
  "Adaugă aplicația pe telefon sau computer pentru acces instant, pe tot ecranul, direct de pe ecranul principal — exact ca o aplicație nativă. Nu ocupă spațiu și nu trece prin App Store.": "Add the app to your phone or computer for instant, full-screen access straight from your home screen — just like a native app. It takes no space and doesn't go through the App Store.",
  "Aplicația este deja instalată. O poți deschide de pe ecranul principal.": "The app is already installed. You can open it from your home screen.",
  "Instalează acum": "Install now",
  "Cel mai simplu — browserul tău acceptă instalarea cu un clic.": "Easiest way — your browser supports one-click install.",
  "Rapid": "Fast",
  "Se deschide instant, pe tot ecranul, fără bara browserului.": "Opens instantly, full-screen, without the browser bar.",
  "Pe ecranul principal": "On your home screen",
  "Iconiță KLUS lângă celelalte aplicații.": "A KLUS icon next to your other apps.",
  "Comod": "Convenient",
  "Un singur tap pentru randări noi, oriunde te afli.": "One tap for new renders, wherever you are.",
  "Windows sau Mac (Chrome / Edge)": "Windows or Mac (Chrome / Edge)",
  "Deschide aplicația în": "Open the app in",
  "sau": "or",
  "În bara de adrese (dreapta), apasă pictograma de": "In the address bar (right), click the",
  "instalare": "install",
  "(un monitor cu o săgeată). Alternativ, meniul": "icon (a monitor with an arrow). Alternatively, the menu",
  "„Instalează KLUS AI Studio…”": "\"Install KLUS AI Studio…\"",
  "Confirmă apăsând": "Confirm by clicking",
  "„Instalează”": "\"Install\"",
  "Aplicația apare în meniul Start / Launchpad și se deschide într-o fereastră proprie.": "The app appears in the Start menu / Launchpad and opens in its own window.",
  "Sfat: dacă folosești butonul": "Tip: if you use the",
  "„Instalează acum”": "\"Install now\"",
  "de mai sus, sari peste toți pașii.": "button above, you can skip all the steps.",
  "Android (Chrome)": "Android (Chrome)",
  "Apasă meniul cu": "Tap the",
  "trei puncte": "three-dot menu",
  "(dreapta sus).": "(top right).",
  "Alege": "Choose",
  "„Instalează aplicația”": "\"Install app\"",
  "„Adaugă pe ecranul principal”": "\"Add to Home screen\"",
  "Confirmă cu": "Confirm with",
  "Iconița KLUS apare pe ecranul principal.": "The KLUS icon appears on your home screen.",
  "Dacă apare automat bannerul": "If the",
  "jos, apasă-l direct.": "banner appears automatically at the bottom, just tap it.",
  "iPhone / iPad (Safari)": "iPhone / iPad (Safari)",
  "Deschide aplicația neapărat în": "Be sure to open the app in",
  "(nu în Chrome pe iOS).": "(not Chrome on iOS).",
  "Apasă butonul": "Tap the",
  "Partajare": "Share",
  "(pătrat cu săgeată în sus), în bara de jos.": "button (a square with an up arrow) in the bottom bar.",
  "Derulează și alege": "Scroll and choose",
  "„Adaugă la ecranul principal”": "\"Add to Home Screen\"",
  "Apasă": "Tap",
  "„Adaugă”": "\"Add\"",
  "(dreapta sus). Iconița KLUS apare pe ecranul principal.": "(top right). The KLUS icon appears on your home screen.",
  "Notă: pe iPhone/iPad, instalarea se face doar din": "Note: on iPhone/iPad, installation is only possible from",
  "— butonul automat de instalare nu este disponibil (limitare Apple).": "— the automatic install button isn't available (Apple limitation).",
  "Instalează aplicația KLUS": "Install the KLUS app",
  "Acces instant de pe ecranul principal, pe tot ecranul.": "Instant full-screen access from your home screen.",
  "Instalează": "Install",
  "Vezi cum": "See how",

  // ---- Landing ----
  "Distribuitor oficial KLUS · Vision AI": "Official KLUS distributor · Vision AI",
  "Vezi cum arată": "See how",
  "iluminatul LED": "LED lighting",
  "în spațiul tău.": "looks in your space.",
  "Încarcă o fotografie, iar KLUS AI Lighting Studio generează randări cu iluminat arhitectural și îți calculează lista de materiale — profile, benzi, corpuri și accesorii de pe klusled.ro.": "Upload a photo and KLUS AI Lighting Studio generates architectural lighting renders and calculates your bill of materials — profiles, strips, fixtures and accessories from klusled.ro.",
  "Începe randarea": "Start rendering",
  "Vezi magazinul KLUS": "Browse the KLUS shop",
  "Necesită cont gratuit ·": "Requires a free account ·",
  "9 randări foto": "9 photo renders",
  "incluse. Doriți mai multe imagini aplicate pentru proiectul dumneavoastră,": "included. Need more images for your project?",
  "contactați": "Contact",
  "un consultant KLUS.": "a KLUS consultant.",
  "Minimal Arhitectural": "Architectural Minimal",
  "Contur Liniar": "Linear Contour",
  "Cum funcționează": "How it works",
  "Trei pași simpli, de pe orice telefon.": "Three simple steps, from any phone.",
  "1. Încarcă o fotografie": "1. Upload a photo",
  "Fă o poză spațiului tău — interior sau fațadă — direct de pe telefon.": "Take a photo of your space — interior or façade — right from your phone.",
  "2. Vision AI + 9 randări": "2. Vision AI + 9 renders",
  "AI-ul analizează spațiul și generează 3 concepte odată — până la 9 randări foto LED.": "The AI analyzes the space and generates 3 concepts at once — up to 9 LED photo renders.",
  "3. Deviz & ofertă": "3. Bill of materials & offer",
  "Primești lista de materiale defalcată, cu preț estimativ și link către magazin.": "You get an itemized bill of materials with an estimated price and a link to the shop.",
  "Doar produse KLUS reale": "Real KLUS products only",
  "Fiecare randare folosește profile, benzi, corpuri și accesorii existente pe klusled.ro.": "Every render uses profiles, strips, fixtures and accessories available on klusled.ro.",
  "Optimizat pentru telefon": "Optimized for phone",
  "Interfață rapidă, gândită mobile-first, cu fotografiere directă.": "A fast, mobile-first interface with direct photo capture.",
  "Estimare + validare vânzări": "Estimate + sales validation",
  "Preț orientativ automat, apoi ofertă finală de la consultanții KLUS.": "Automatic ballpark price, then a final offer from KLUS consultants.",
  "Gata să-ți luminezi proiectul?": "Ready to light up your project?",
  "Creează un cont și generează prima randare în câteva secunde.": "Create an account and generate your first render in seconds.",
  "Începe acum": "Get started",
  "Distribuitor oficial KLUS": "Official KLUS distributor",
  "Randările au caracter orientativ și necesită validare tehnică finală.": "Renders are indicative and require final technical validation.",

  // ---- Privacy ----
  "Politica de confidențialitate": "Privacy Policy",
  "Operatorul datelor cu caracter personal este": "The personal data controller is",
  "CUI RO35285172, Nr. Reg. Com. J2019001504231, cu sediul social în Șos. Erou Iancu Nicolae nr. 107C, Parter, Camera 2, Voluntari, Ilfov.": "VAT RO35285172, Trade Reg. No. J2019001504231, registered office at Șos. Erou Iancu Nicolae no. 107C, Ground Floor, Room 2, Voluntari, Ilfov.",
  "Prin crearea unui cont în KLUS AI Lighting Studio, îți exprimi consimțământul pentru prelucrarea datelor tale cu caracter personal (nume, email, telefon, județ, tip client) în scopul contactării comerciale și al statisticilor interne, conform Regulamentului (UE) 2016/679 (GDPR).": "By creating an account in KLUS AI Lighting Studio, you consent to the processing of your personal data (name, email, phone, county, client type) for commercial contact and internal statistics, in accordance with Regulation (EU) 2016/679 (GDPR).",
  "Fotografiile încărcate și randările generate sunt stocate securizat și sunt șterse la 90 de zile de la închiderea proiectului, dacă nu există o cerință legală contrară. Proiectele inactive se păstrează 12 luni.": "Uploaded photos and generated renders are stored securely and deleted 90 days after the project is closed, unless a legal requirement states otherwise. Inactive projects are kept for 12 months.",
  "Consimțământul de marketing este opțional și poate fi retras oricând. Ai dreptul de acces, rectificare, ștergere, restricționare, portabilitate și opoziție. Pentru exercitarea acestor drepturi ne poți contacta la adresa de email a operatorului.": "Marketing consent is optional and can be withdrawn at any time. You have the right to access, rectification, erasure, restriction, portability and objection. To exercise these rights you can contact us at the controller's email address.",
  "Rezultatele generate de AI au caracter orientativ și necesită validare tehnică finală de către un specialist KLUS.": "AI-generated results are indicative and require final technical validation by a KLUS specialist.",
  "Înapoi la înregistrare": "Back to registration",

  // ---- Projects ----
  "Ștergi acest proiect?": "Delete this project?",
  "Proiect șters": "Project deleted",
  "Proiect nou": "New project",
  "Nu ai încă niciun proiect.": "You don't have any projects yet.",
  "Creează primul proiect": "Create your first project",
  "randări": "renders",
  "Detalii proiect": "Project details",
  "Acest proiect nu are randări încă.": "This project has no renders yet.",
  "Generează randări": "Generate renders",
  "Ciornă": "Draft",
  "Randat": "Rendered",
  "Ofertă cerută": "Offer requested",

  // ---- Catalog ----
  "Catalog KLUS": "KLUS Catalog",
  "produse din klusled.ro": "products from klusled.ro",
  "Deschide magazinul": "Open the shop",
  "Caută produs sau cod SKU…": "Search product or SKU…",
  "Caută": "Search",
  "Toate": "All",
  "Niciun produs găsit.": "No products found.",
  "Anterior": "Previous",
  "Următor": "Next",

  // ---- Sales ----
  "Cereri de ofertă": "Offer requests",
  "Gestionează solicitările clienților și completează ofertele.": "Manage client requests and complete offers.",
  "Nicio cerere de ofertă.": "No offer requests.",
  "Estimare:": "Estimate:",
  "Ofertă:": "Offer:",
  "Cerere ofertă": "Offer request",
  "Mesaj client": "Client message",
  "Variantă aleasă:": "Chosen variant:",
  "Descarcă oferta PDF": "Download offer PDF",
  "Status": "Status",
  "Total ofertă (lei)": "Offer total (RON)",
  "Note interne": "Internal notes",
  "Șterge cererea": "Delete request",
  "Cerere actualizată": "Request updated",
  "Ștergi definitiv această cerere de ofertă?": "Permanently delete this offer request?",
  "Cerere ștearsă": "Request deleted",
  "Toate": "All",
  "Noi": "New",
  "În lucru": "In progress",
  "Ofertate": "Quoted",
  "Închise": "Closed",
  "nou": "new",
  "in_lucru": "in progress",
  "ofertat": "quoted",
  "inchis": "closed",

  // ---- Admin ----
  "Administrare": "Administration",
  "Utilizatori": "Users",
  "Clienți": "Clients",
  "Proiecte": "Projects",
  "Randări": "Renders",
  "Cereri noi": "New requests",
  "Produse": "Products",
  "Sincronizare catalog klusled.ro": "klusled.ro catalog sync",
  "Stare:": "Status:",
  "necunoscut": "unknown",
  "produse": "products",
  "Se importă…": "Importing…",
  "Reimportă catalog": "Re-import catalog",
  "Adaugă utilizator": "Add user",
  "Nume": "Name",
  "Județ": "County",
  "Rol": "Role",
  "Șterge utilizatorul": "Delete user",
  "Import pornit. Se actualizează în fundal.": "Import started. Updating in the background.",
  "Rol actualizat": "Role updated",
  "Ștergi definitiv contul": "Permanently delete the account",
  "și toate datele lui (proiecte, randări, oferte)?": "and all its data (projects, renders, offers)?",
  "Utilizator șters": "User deleted",
  "Completează nume, email și parolă (min. 6 caractere).": "Fill in name, email and password (min. 6 characters).",
  "Utilizator creat": "User created",
  "Creează un cont de vânzător sau administrator.": "Create a sales or administrator account.",
  "Telefon (opțional)": "Phone (optional)",
  "Creează utilizator": "Create user",

  // ---- Studio ----
  "Ai": "You have", "din": "of", "randări rămase.": "renders remaining.",
  "Randări nelimitate (cont intern).": "Unlimited renders (internal account).",
  "Fă o poză sau încarcă o imagine": "Take a photo or upload an image",
  "Interior sau fațadă · JPG / PNG, max 12MB": "Interior or façade · JPG / PNG, max 12MB",
  "Apasă pentru a selecta": "Tap to select",
  "Alege din galerie": "Choose from gallery",
  "Fă o poză": "Take a photo",
  "Nume proiect": "Project name",
  "Tip spațiu": "Space type",
  "Interior": "Interior", "Exterior": "Exterior",
  "Spațiu": "Space",
  "Obiectiv iluminat": "Lighting objective",
  "Fotografie": "Photo",
  "Ascunde desenare": "Hide drawing",
  "✏️ Desenează zone pe poză": "✏️ Draw zones on photo",
  "Zone de iluminat (alege una sau mai multe)": "Lighting zones (choose one or more)",
  "Dacă nu alegi nimic, AI-ul detectează automat zonele potrivite.": "If you choose nothing, the AI auto-detects suitable zones.",
  "Temperatură culoare": "Color temperature",
  "Intensitate": "Intensity",
  "Lungime estimată traseu LED": "Estimated LED run length",
  "Alege zone mai sus pentru a introduce lungimea separat pe fiecare. Altfel, AI-ul detectează automat.": "Choose zones above to set a length for each. Otherwise the AI decides automatically.",
  "Lungime traseu LED pe zonă": "LED run length per zone",
  "Total": "Total",
  "sugerat din desen": "suggested from drawing",
  "Zonele desenate pe poză primesc o lungime sugerată automat — ajusteaz-o oricând. Devizul se calculează din suma reală pe zone.": "Zones drawn on the photo get an auto-suggested length — adjust anytime. The estimate is computed from the real per-zone total.",
  "Include corpuri de iluminat KLUS": "Include KLUS light fixtures",
  "Adaugă sisteme/corpuri gata asamblate în deviz.": "Add pre-assembled systems/fixtures to the estimate.",
  "Se generează 3 randări…": "Generating 3 renders…",
  "Generează 3 randări AI": "Generate 3 AI renders",
  "Ai atins limita. Trimite o cerere de ofertă pentru a continua.": "You've reached the limit. Send an offer request to continue.",
  "randări generate!": "renders generated!",
  "Analiză Vision AI": "Vision AI analysis",
  "3 concepte de iluminat": "3 lighting concepts",
  "Lista de materiale (BOM)": "Bill of materials (BOM)",
  "estimare": "estimate",
  "Cerere trimisă. Echipa KLUS te va contacta.": "Request sent. The KLUS team will contact you.",
  "Mulțumit de rezultat? Trimite lista către echipa de vânzări pentru ofertă finală.": "Happy with the result? Send the list to the sales team for a final offer.",
  "Schimbă poza": "Change photo",
  "Încă 3 randări": "3 more renders",
  "Descarcă oferta PDF": "Download offer PDF",
  "Solicită ofertă": "Request offer",
  "Rezumatul ofertei tale": "Your offer summary",
  "Total estimativ": "Estimated total",
  "Lungimi pe zonă": "Lengths per zone",
  "Pe categorii": "By category",
  "Ai folosit cele 9 randări incluse.": "You've used all 9 included renders.",
  "Pentru mai multe variante, echipa noastră de vânzări îți stă la dispoziție.": "For more variants, our sales team is at your service.",
  "Solicită ofertă personalizată": "Request a personalized offer",
  "Trimitem lista de materiale și randarea aleasă către consultanții KLUS.": "We send the bill of materials and the chosen render to the KLUS consultants.",
  "Mesaj (opțional)": "Message (optional)",
  "Detalii despre proiect, termene, buget…": "Project details, deadlines, budget…",
  "Variantă selectată:": "Selected variant:",
  "Trimite cererea": "Send request",
  "Cererea de ofertă a fost trimisă echipei de vânzări!": "Your offer request was sent to the sales team!",
  "Se pregătește PDF-ul…": "Preparing the PDF…",
  "Încarcă o fotografie mai întâi.": "Upload a photo first.",
  "Continuă": "Continue",
  "Înapoi": "Back",
  // rooms
  "Living": "Living room", "Dormitor": "Bedroom", "Bucătărie": "Kitchen", "Baie": "Bathroom",
  "Hol / Scări": "Hallway / Stairs", "Birou": "Office", "Comercial / HoReCa": "Commercial / HoReCa",
  "Fațadă casă": "House façade", "Fațadă clădire": "Building façade", "Grădină / Peisaj": "Garden / Landscape",
  "Terasă / Pergolă": "Terrace / Pergola", "Alee / Acces": "Path / Access", "Piscină": "Pool",
  // objectives
  "Iluminat ambiental": "Ambient lighting", "Accent arhitectural": "Architectural accent",
  "Iluminat funcțional": "Functional lighting", "Efect decorativ": "Decorative effect",
  "Iluminat de siguranță": "Safety lighting",
  // zones
  "Contur tavan": "Ceiling contour", "Nișă": "Niche", "Spate mobilier": "Behind furniture",
  "Soclu / Plintă": "Skirting / Plinth", "Rafturi / Bibliotecă": "Shelves / Bookcase",
  "Oglindă / Baie": "Mirror / Bathroom", "Blat bucătărie": "Kitchen worktop", "Trepte scări": "Stair steps",
  "Contur fațadă": "Façade contour", "Streașină": "Eaves", "Gard / Împrejmuire": "Fence / Enclosure",
  "Trepte / Alee": "Steps / Path", "Copaci / Peisaj": "Trees / Landscape", "Intrare": "Entrance",
  // intensities
  "Discretă": "Subtle", "Medie": "Medium", "Puternică": "Strong",
};
